import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// eslint-disable-next-line import/no-cycle
import { RootState } from './store';
import { loggedOut } from './system';

interface Company {
  id: string;
  name: string;
}
interface State {
  info: Company;
}

export const initialState: State = {
  info: { id: '', name: '' },
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompanyInfo: (state: State, action: PayloadAction<Company>) => {
      state.info = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(loggedOut, state => {
      state.info = initialState.info;
    });
  },
});

export default companySlice;

export const getCompanyInfo = (state: RootState) => state[companySlice.name].info;

export const {
  actions: { setCompanyInfo },
  reducer: companyReducer,
} = companySlice;
